
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 8.504a.5.5 0 00.5.5h23a.5.5 0 000-1H.5a.5.5 0 00-.5.5zM23.5 15.012H.5a.5.5 0 100 1h23a.5.5 0 000-1z"}}),_c('circle',{attrs:{"cx":"22","cy":"22","r":"2"}}),_c('circle',{attrs:{"cx":"2","cy":"2","r":"2"}})])
          )
        }
      }
    